import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import {
  IoMenu,
  IoLogOutOutline,
  IoBusiness,
  IoChevronDown,
} from "react-icons/io5";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useLoginResult } from "../State/LoginResultContext";
import { showToast } from "../utils/toast";
import { API_URL } from "../utils/constants";

const userNavigation = [
  { name: "My Events", href: "/my-events" },
  { name: "Dashboard", href: "/overview" },
  { name: "Team Members", href: "/team-members" },
  { name: "Profile", href: "/profile" },
  { name: "Manage Subscription", href: "/manage-plan" },
  { name: "Contact Us", href: "/contact-us" },
  { name: "Log Out", href: "/signout" },
];

const AppHeader = ({
  isSuperUser,
  loginResults,
  className,
  hideMobileMenu,
  mobileLeading,
  ...rest
}) => {
  const location = useLocation();

  const { updateloginResults } = useLoginResult();

  const handleOrgSelect = async (org) => {
    try {
      const response = await fetch(
        API_URL + `/users/${org.id}/provisionOrgData`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${loginResults.token}`,
          },
        },
      );

      const data = await response.json();

      if (response.status === 200) {
        const updateUserData = {
          ...loginResults,
          ...data,
          activeOrganization: org,
        };

        updateloginResults(updateUserData);
        showToast(`${org.name} is active organization`, { type: "success" });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        showToast("Something went wrong!", { type: "error" });
      }
    } catch (error) {
      showToast(error.message, { type: "error" });
    }
  };
  const isPathActive = (href) =>
    location.pathname === href ||
    (href !== "/" && location.pathname.startsWith(`${href}/`));

  return (
    <div
      className={`relative flex items-center px-4 py-6 sm:justify-between sm:py-4 sm:bg-[#17012E] ${
        hideMobileMenu ? "justify-between" : "justify-end"
      } ${className || ""}`}
      {...rest}
    >
      {hideMobileMenu ? (
        <div className="relative z-10 flex shrink-0 items-center justify-start">
          {mobileLeading}
        </div>
      ) : null}

      <Link
        to="/my-events"
        className="absolute left-1/2 top-1/2 z-[1] -translate-x-1/2 -translate-y-1/2 sm:static sm:translate-x-0 sm:translate-y-0"
      >
        <img
          src="logo192.png"
          alt="Seymour Logo"
          className="h-10 w-auto rounded-full"
        />
      </Link>

      {hideMobileMenu ? (
        <div className="relative z-10 h-10 w-10 shrink-0" aria-hidden />
      ) : null}

      {/* <Menu as="div" className="relative">

        <MenuButton className="text-white focus:bg-transparent active:bg-transparent text-4xl cursor-pointer focus:outline-none flex items-center justify-center p-0 border-none outline-none ring-0 !bg-transparent hover:!bg-transparent">
          <IoBusiness className="w-8 h-auto" /> <NavLink
               
                  className={`block p-2 my-[1px] first:mt-0 last:mb-0 text-sm font-medium atkinson-font tracking-tight rounded-lg flex items-center gap-2 text-white`}
                >
                  {loginResults?.activeOrganization?.name}  <IoChevronDown className="w-4 h-4 text-white" />
                </NavLink>
        </MenuButton>
        <MenuItems
          transition
          className="absolute right-0 z-50 mt-2.5 w-48 origin-top-right rounded-lg bg-white p-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
        >
          {[...loginResults?.userOrgs, ...loginResults?.membershipOrgs].map((item) => (
            <MenuItem key={item.name}>
              {({ focus }) => (
                <NavLink
                  onClick={() => handleOrgSelect(item)}
                  className={`block p-2 my-[1px] first:mt-0 last:mb-0 text-sm font-medium atkinson-font tracking-tight rounded-lg flex items-center gap-2 ${
                    item.name === "Log Out"
                      ? "text-red-600 hover:text-red-700"
                      : focus || isPathActive(item.href)
                      ? "bg-[#28094C] text-white"
                      : "text-black"
                  }`}
                >
                  {item.name}
                </NavLink>
              )}
            </MenuItem>
          ))}
       

        </MenuItems>
      </Menu>*/}

      {/* Menu (hidden on mobile when e.g. Edit Event uses back + logo only) */}
      {!hideMobileMenu ? (
        <Menu as="div" className="relative">
          <MenuButton className="text-white focus:bg-transparent active:bg-transparent text-4xl cursor-pointer focus:outline-none flex items-center justify-center p-0 border-none outline-none ring-0 !bg-transparent hover:!bg-transparent">
            <IoMenu className="w-8 h-auto" />
          </MenuButton>
          <MenuItems
            transition
            className="absolute right-0 z-50 mt-2.5 w-48 origin-top-right rounded-lg bg-white p-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
          >
            {userNavigation.map((item) => (
              <MenuItem key={item.name}>
                {({ focus }) => (
                  <NavLink
                    to={item.href}
                    className={`block p-2 my-[1px] first:mt-0 last:mb-0 text-sm font-medium atkinson-font tracking-tight rounded-lg flex items-center gap-2 ${
                      item.name === "Log Out"
                        ? "text-red-600 hover:text-red-700"
                        : focus || isPathActive(item.href)
                          ? "bg-[#28094C] text-white"
                          : "text-black"
                    }`}
                  >
                    {item.name === "Log Out" && (
                      <IoLogOutOutline className="w-4 h-4" />
                    )}
                    {item.name}
                  </NavLink>
                )}
              </MenuItem>
            ))}
            {isSuperUser ? (
              <MenuItem>
                {({ focus }) => (
                  <NavLink
                    to={"/customers"}
                    className={`block p-2 my-[1px] first:mt-0 last:mb-0 text-sm font-medium atkinson-font tracking-tight rounded-lg flex items-center gap-2 ${
                      focus || isPathActive("/customers")
                        ? "bg-[#28094C] text-white"
                        : "text-black"
                    }`}
                  >
                    Customers
                  </NavLink>
                )}
              </MenuItem>
            ) : (
              ""
            )}
          </MenuItems>
        </Menu>
      ) : null}
    </div>
  );
};

export default AppHeader;
